import { BaseFormSchema } from './form-schema';

export const defaultRecommendations: BaseFormSchema['recommendations'] = [
  {
    value: '<b>Provide actionable insights</b> based on the campaign results',
  },
  {
    value: '<b>Suggest areas of improvement</b> for future campaigns',
  },
  {
    value:
      '<b>Keep it simple</b> and use the <b>Who, What, Where</b> Highlights',
  },
  {
    value: '<b>Reinforce Value</b> here from slide 13',
  },
];
